import React from 'react';

const OsechiLayout = ({ children, ...props }) => {
  return (
      <div>
        {
          children
        }
      </div>
  );
};

export default OsechiLayout;
